<template>
    <BaseSection
        width="page-narrow"
    >
        <ClientOnly>
            <TypeformEmbed :url="entryLinkExternal[0]?.externalUrl" />
        </ClientOnly>
    </BaseSection>
</template>

<script setup>
defineProps({
    entryLinkExternal: {
        type: Array,
        default() {
            return [];
        }
    }
});
</script>
